import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/tomos';
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-azul/10 bg-ink-2" data-id="element-16" data-mp="plslc7o6v6at">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-17" data-mp="autf33atstue">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-18" data-mp="ftmwv7x5b70d">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>
        <p className="mt-3 text-center text-sm font-semibold uppercase tracking-[0.18em] text-azul-soft" data-id="element-19" data-mp="1whoh19ylw1y">
          Tu arsenal de ventaja competitiva
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3o2wsxj8lq7nr">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex flex-col rounded-2xl border border-plata/20 bg-ink p-6" data-id="element-21" data-mp="3t1rcwoib229g" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-22" data-mp="3dek5ha5hgpnx">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-plata/15 px-3 py-1 text-xs font-bold text-plata" data-id="element-23" data-mp="3r5oulib85zk0">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-24" data-mp="3n5y7bokwq1k8" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-25" data-mp="2zg3wfck5en2m">
                  <span className="text-white/40 line-through" data-id="element-26" data-mp="2uh0rrt82yiv6">{b.price}</span>{' '}
                  <span className="text-naranja-soft" data-id="element-27" data-mp="38g8v8yba0d56">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-28" data-mp="33hfdgtoyhzz7">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-29" data-mp="33jif6azh1hjr">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-naranja/40 bg-naranja/10 p-6 text-center" data-id="element-30" data-mp="irgbr1yi8n51">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-31" data-mp="3cjfyzdkyarjg">
            Valor total de los bonos: <span className="text-white/50 line-through" data-id="element-32" data-mp="3hhhs6rc3c78n">$61</span>{' '}
            <span className="text-[15px] text-naranja-soft" data-id="element-33" data-mp="3hjua54humhlp">HOY GRATIS CON TU PACK</span>
          </p>
        </div>
      </div>
    </section>;
}